import { Injectable } from "@angular/core";
import { Observable, of } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { MapsService } from "../../../../../../core/service/google/maps/maps.service";

export interface PlaceResult {
  place_id: string;
  description: string;
  main_text?: string;
  secondary_text?: string;
  location?: {
    lat: number;
    lng: number;
  };
}

@Injectable({ 'providedIn': 'root' })
export class SearchBarAddressesMapsService {
  constructor(public mapsService: MapsService) {}

  /**
   * Busca direcciones basadas en un texto de consulta
   */
  searchAddresses(query: string): Observable<PlaceResult[]> {
    if (!query || query.trim() === '') {
      return of([]);
    }

    return this.mapsService.searchAddresses(query).pipe(
      map(predictions => {
        return predictions.map(prediction => ({
          place_id: prediction.place_id,
          description: prediction.description,
          main_text: prediction.structured_formatting?.main_text,
          secondary_text: prediction.structured_formatting?.secondary_text
        }));
      }),
      catchError(error => {
        console.error('Error al buscar direcciones:', error);
        return of([]);
      })
    );
  }

  /**
   * Obtiene los detalles de un lugar por su ID
   */
  getPlaceDetails(placeId: string): Observable<google.maps.GeocoderResult | null> {
    return this.mapsService.getPlaceDetails(placeId);
  }
}